import {Link} from "react-router-dom";
import useHorizon from "../../hooks/useHorizon";

const ActionSection = () => {
    const slideInLeftShortAnimation = useHorizon({preset: 'slideInLeftShort', duration: '1000ms', threshold: 1});
    const slideInRightShortAnimation = useHorizon({preset: 'slideInRightShort', duration: '1000ms', delay: '300ms', threshold: 1});

    return (
        <div className="section-block pt-40 pb-40">
            <div className="row flex">
                <div className="column width-8 left horizon" {...slideInLeftShortAnimation}>
                    <p className="lead mb-0 mb-mobile-20">지금 바로 회원가입 하신 후 흑우촌 메타버스를 경험해보세요.<br/>계정을 만들고 접속하는 것까지 전부 무료입니다.
                    </p>
                </div>
                <div className="column width-4 v-align-middle horizon right left-on-mobile" {...slideInRightShortAnimation}>
                    <div>
                        <Link to="/register"
                              className="button rounded medium no-margins bkg-theme bkg-hover-theme color-white color-hover-white mb-0">회원가입</Link>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ActionSection;